import React, { useEffect, useState } from 'react';
import './payment-summary.sass';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import { Dropdown, DropdownSize } from '../../../../../components/interface/input/dropdown/dropdown';
import { DateService } from '../../payment-date-service/payment-date.service';
import { useDispatch, useSelector } from 'react-redux';
import { getDownloadInvoice, getTransactionsSummary } from '../../dashboard-payment.slice';
import { getTeamVendorId } from '../../../../login/session.slice';
import { toast } from 'react-toastify';

export const PaymentSummary = ({transactionsPeriod}) => {

  const getSummaryPeriod = () => {
    let date = new Date();
    return {period: date.getFullYear() + '-' + ('0' + (date.getUTCMonth() + 1)).slice(-2)};
  };

  const getDropdownOptions = () => {
    return transactionsPeriod?.map(e => ({
      label: e.periodFrom + ' - ' + e.periodTo, value: {...e}
    }));
  };

  const [invoiceUrl, setInvoiceUrl] = useState();
  const [billingOptions, setBillingOptions] = useState(getDropdownOptions());
  const dispatch = useDispatch();
  const sessionData = useSelector(state => state.session);
  const vendorId = getTeamVendorId(sessionData);
  const paymentSummary = useSelector(state => state.dashboardPayment.transactionsSummary);
  const isDisabledDownload = useSelector(state => state.dashboardPayment.isDisabledDownload);

  const filter = getSummaryPeriod();

  useEffect(() => {
    dispatch(getTransactionsSummary({vendorId, filter}));
    setBillingOptions(getDropdownOptions());
  }, []);

  //[
  //  { // Aktualny period
  //    "periodFrom": "2023-05",
  //    "periodTo": "2023-05"
  //  },
  //  { // Poprzednie, z linkiem do faktury
  //    "periodFrom": "2022-05",
  //    "periodTo": "2023-03",
  //    "invoiceUrl": "https://s3.eu-central-1.amazonaws.com/vv-files/transaction/1ecd7eae-f554-68da-87af-1390b4e1ca2d/463b38e5-beb3-4ff3-941e-5292c4adb182.pdf"
  //  },
  //]

  const getSummary = (val) => {
    setInvoiceUrl(val.invoiceUrl);
    dispatch(getTransactionsSummary({vendorId, filter: {periodFrom: val.periodFrom, periodTo: val.periodTo}}));
  };

  const downloadInvoice = () => {
    if (!paymentSummary?.total_amount) {
      toast.error('Nie można pobrać faktury dla tego okresu, suma transakcji musi wynosić więcej niż zero.');
    } else if (!invoiceUrl.url) {
      toast.error('Nie udało się pobrać faktury');
    } else {
      toast.success('Pobieranie faktury');
    }
  };

  const displayValue = (value) => {
    return `${value / 100} zł`;
  };

  return (
    <div className='vv-payment-summary'>
      <div className='vv-payment-summary__dropdown'>
        <Dropdown name='billing-period' id='billing-period' label='Okres rozliczeniowy' options={billingOptions}
                  size={DropdownSize.SMALL} placeholder='Okres...' onChange={(option) => getSummary(option.value)}/>
      </div>
      <div className='vv-payment-summary__container'>
        <span className='vv-payment-summary__label'>Kwota transaksji w okresie rozliczeniowym</span>
        <span className='vv-payment-summary__value'>{displayValue(paymentSummary?.total_amount?.amount ?? 0)}</span>
      </div>
      <div className='vv-payment-summary__container'>
        <span className='vv-payment-summary__label'>Kwota prowizji</span>
        <span className='vv-payment-summary__value'>{displayValue(paymentSummary?.total_vice_versa?.amount ?? 0)}</span>
      </div>
      <div className='vv-payment-summary__container'>
        <span className='vv-payment-summary__label'>Ilość transakcji</span>
        <span className='vv-payment-summary__value'>{paymentSummary?.count}</span>
      </div>
      {invoiceUrl && <a href={invoiceUrl} download><Button disabled={isDisabledDownload} text='pobierz fakturę'
                                                 buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR}
                                                 onClick={downloadInvoice}/></a>}
    </div>
  );
};
